<div class="main_header">
    <h1>Attribution Fee</h1>
</div>

<div class="step_container">
    <div *ngIf="isVDSP_enabled && initial_vdsp_flag">
        <app-commission
            [step_input]="{isEdit: isEdit, dsp: 'Global Audiences & Inventory', commissionType: 'vdsp_oc', adspRegion: null, timezone: step_input.timezone,
        active_commission: vdsp_off_commission_data.active_offline_commission.commission, editPermission: editPermission,
        clientType: client, clientId: client_id, commissionMin: 0, commissionMax: 80, commissionLabel: 'Offline Attribution Commission'}">
        </app-commission>
    </div>
</div>
<div class="main_footer align_right">
    <button mat-button class="action_btn_no-border me-2 mb-2" (click)="cancel()">
        Cancel
    </button>
    <button mat-button class="delete-action-btn me-3" (click)="back()">
        Previous
    </button>
    <button mat-button [ngClass]="{'create-btn': true}" (click)="proceed()">
        next
    </button>
</div>
